/**
 * Converts a pokemon name (e.g. from POKE_DATA) to the format used by the sprite/portrait assets.
 *
 * Replaces hyphen-separated suffixes with double underscores and handles special cases like mega X/Y and Gigantamax.
 */
export const parsePokeNameForSprite = (name: string): string => {
  // Special handling for Mime Jr. which has a trailing underscore in assets
  if (name === "mime-jr") return "mime_jr_";

  let formattedName = name;

  // Special cases for names that use underscores instead of hyphens in assets
  const specialCases: Record<string, string> = {
    "porygon-z": "porygon_z",
    "jangmo-o": "jangmo_o",
    "hakamo-o": "hakamo_o",
    "kommo-o": "kommo_o",
    "type-null": "type_null",
    "mr-mime": "mr_mime",
    "mr-rime": "mr_rime",
  };

  for (const [key, value] of Object.entries(specialCases)) {
    if (formattedName.startsWith(key)) {
      formattedName = formattedName.replace(key, value);
      break;
    }
  }

  return formattedName
    .replace("-mega-x", "__mega_x")
    .replace("-mega-y", "__mega_y")
    .replace("-mega", "__mega")
    .replace("-alola", "__alola")
    .replace("-hisui", "__hisui")
    .replace("-galar", "__galar")
    .replace("-paldea", "__paldea")
    .replace("-gmax", "__gigantamax")
    .replace("-primal", "__primal")
    .replace("-unbound", "__unbound");
};
